import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import { Color } from '../../../app/models/Color';
import useColorService from '../../../app/services/hooks/useColorService';
import ColorFormContainer from './ColorFormContainer';

interface Props {
    colorId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const ColorEdit = ({ colorId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { fetchingEditColor, editColor, fetchingUpdateColor, updateColor } =
        useColorService();

    const [color, setColor] = useState<Color>({ name: '', description: '' });
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando color...');
        editColor(colorId, {
            onSuccess: (response: ServiceResponse) => {
                setColor(response.data.color);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando color...');
        updateColor(colorId, color, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, { autoClose: 2500 });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditColor ? (
        <LazyLoading height="300" />
    ) : (
        <ColorFormContainer
            fetching={fetchingUpdateColor}
            action={update}
            cancel={cancel}
            color={color}
            setColor={setColor}
            errorFields={errorFields}
        />
    );
};

export default ColorEdit;
